import { render, staticRenderFns } from "./UnreviwedUploads.vue?vue&type=template&id=486a5a96&scoped=true&"
import script from "./UnreviwedUploads.vue?vue&type=script&lang=js&"
export * from "./UnreviwedUploads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486a5a96",
  null
  
)

export default component.exports